const tqCommonTracker = {
    track: (type, params = {}) => {
        if (!window.bigTj || typeof window.bigTj.track !== 'function') return;

        try {
            window.bigTj.track(type, tqCommonTracker.getTrackParams(params));
        } catch (e) {
            console.log(e);
        }
    },
    getTrackParams(params = {}) {
        return {
            item_id: '',
            item_name: '',
            item_sort: '1',
            location: '',
            page_source_type: '',
            location_id: '',
            location_sort: '1',
            sa_card_id: '',
            ...params,
        };
    },
};

export default tqCommonTracker;
